/**
 * Sticky Banner (D-20) — live shipped this as an inline IIFE inside
 * sections/section-sticky-banner.liquid; the house architecture moves it here
 * as a custom element. Behaviour is live's, 1:1: toggle .is-visible once the
 * page has scrolled past data-show-after (default 300px), passively.
 *
 * The add-to-cart button inside the banner is handled by the existing
 * [data-promo-atc] machinery in assets/promo-products.js — nothing
 * cart-mutating lives here.
 */
if (!customElements.get('sticky-banner')) {
  customElements.define(
    'sticky-banner',
    class StickyBanner extends HTMLElement {
      connectedCallback() {
        this._checkScroll = this._checkScroll.bind(this);
        window.addEventListener('scroll', this._checkScroll, { passive: true });
        this._checkScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._checkScroll);
      }

      _checkScroll() {
        const showAfter = parseInt(this.dataset.showAfter) || 300;
        if (window.scrollY > showAfter) {
          this.classList.add('is-visible');
        } else {
          this.classList.remove('is-visible');
        }
      }
    }
  );
}
